/* eslint-disable @typescript-eslint/no-explicit-any -- app instance is untyped */
interface HistoryStep {
  viewId: string;
  event: string;
  params: Record<string, unknown>;
}

const initHistoryManager = ({ bus }: { bus: any }) => {
  const stepStack: HistoryStep[] = [];
  bus.on(
    'history/register',
    ({ viewId, event, params = {} }: { viewId: string; event: string; params?: Record<string, unknown> }) => {
      stepStack.push({ viewId, event, params });
    },
  );
  bus.on('history/stepBack', () => {
    const layersToHide: string[] = [];
    const current = stepStack.pop();

    if (!current) {
      return;
    }

    layersToHide.push(current.viewId);
    for (let i = stepStack.length - 1; i >= 0; --i) {
      if (stepStack[i].event === current.event) {
        const same = stepStack.pop()!;
        layersToHide.push(same.viewId);
      } else {
        break;
      }
    }
    bus.send('layers/hideMultiple', layersToHide);
    const { event, params } = stepStack.pop()!;
    bus.send(event, params);
  });
  bus.on('history/clean', () => {
    stepStack.length = 0;
  });
};
/* eslint-enable @typescript-eslint/no-explicit-any */

export { initHistoryManager };
